import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageMobileExit = lazy(() => import("./layout/index"));

export const routerPageMobileExit: RouterItemType = {
  path: "/exit",
  authorize: false,
  element: <LayoutPageMobileExit />,
};
